import { Reducer } from 'redux';
import { RequestableDataWithEntityError } from 'src/store/types';
import { isType } from 'typescript-fsa';
import {
  advisorProfileRequest,
  advisorProfileRequestSuccess,
  advisorProfileRequestFail,
  setAdvisorProfile,
  setAdvisorProfileSuccess,
  setAdvisorProfileFail
} from './advisorProfile.action';

/**
 * State
 */
export type State = RequestableDataWithEntityError<any[]>;

export const defaultState: State = {
  loading: false,
  error: {},
  lastUpdated: 0,
  data: undefined
};

/**
 * Reducer
 */
// @ts-ignore
const reducer: Reducer<State> = (state: State = defaultState, action) => {
  if (isType(action, advisorProfileRequest)) {
    return { ...state, loading: true };
  }

  if (isType(action, advisorProfileRequestSuccess)) {
    const { payload } = action;

    return {
      ...state,
      data: payload,
      loading: false,
      lastUpdated: Date.now()
    };
  }

  if (isType(action, advisorProfileRequestFail)) {
    const { payload } = action;

    return {
      ...state,
      loading: false,
      error: { ...state.error, read: payload }
    };
  }
  if (isType(action, setAdvisorProfileSuccess)) {
    const { payload } = action;
    return {
      ...state,
      data: payload,
      loading: false,
      lastUpdated: Date.now()
    };
  }
  if (isType(action, setAdvisorProfile)) {
    return { ...state, loading: true };
  }
  if (isType(action, setAdvisorProfileFail)) {
    const { payload } = action;

    return {
      ...state,
      loading: false,
      error: { ...state.error, read: payload }
    };
  }
  return state;
};

export default reducer;
